import {Constructor} from "../../../global/constructor";
import CertificateDynamicInput from "./certificateDynamicInput";
import {Hash} from "~/interfaces/hashInterfaces";
import {ObjectHelper} from "~/helpers/objectHelper";
import {CertificateDynamicInputType} from "../enums/certificateDynamicInputType";

export default function CertificateDynamicInputContainer<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    certificate_dynamic_inputs: Hash<CertificateDynamicInput> = {};

    get certificateDynamicInputs(): CertificateDynamicInput[] {
      return ObjectHelper.toArray(this.certificate_dynamic_inputs)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get certificateDynamicInputsArrayDeep(): CertificateDynamicInput[] {
      const certificateDynamicInputs = []
      this.certificateDynamicInputs.forEach(input =>{
        certificateDynamicInputs.push(input)
        certificateDynamicInputs.push(...input.certificateDynamicInputsArrayDeep)
      })
      return certificateDynamicInputs
    }

    get certificateDynamicObjectInputs(): CertificateDynamicInput[] {
      return this.certificateDynamicInputsArrayDeep.filter(i => i.type === CertificateDynamicInputType.Object);
    }

    findCertificateDynamicInput(clientIdOrId: string): CertificateDynamicInput{
      return this.certificateDynamicInputsArrayDeep.find(x=> x.client_id === clientIdOrId || x.id === clientIdOrId);
    }

    get nextDynamicInputSortOrder(): number {
      const inputs = this.certificateDynamicInputs;
      if (inputs.length === 0) return 0;
      else return inputs[inputs.length - 1].sort_order + 1;
    }

    recalculateDynamicInputPositions() {
      this.certificateDynamicInputs.forEach((it, index) => it.sort_order = index);
    }
  };
}
